module.exports = __webpack_public_path__ + "media/src/website/images/locations/going/going_02-9f47936ae9f6488733b7bfe95b84f9c4.jpg";